(function () {
  'use strict';
  var controllerId = 'parametriAddEdit';
  angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', 'parametri', parametriAddEditFn]);

  function parametriAddEditFn($rootScope, $scope, $uibModalInstance, $filter, datacontext, common, parametri) {
    var getLogFn = common.logger.getLogFn;
    var log = getLogFn(controllerId);
    var logError = getLogFn(controllerId, 'logError');
    var logSuccess = getLogFn(controllerId, 'logSuccess');

    $scope.super = $rootScope.isAuthorized('SUPER');
    $scope.parametri = parametri;
    $scope.item = {};
    $scope.item.aziende = [];
    if ($scope.super)
      getListAziende();
    $scope.titolo = 'Modifica parametri';
    $scope.item.lingua = [{ name: 'Italiano', value: 'it' }, { name: 'Inglese', value: 'en' }];

    $scope.ok = function (isValid) {
      if (isValid) {
        var result = {};

        console.info("scoper parametri ", $scope.parametri);

        editItem($scope.parametri).then(function (result) {
          console.info("result ", result);

          if (result.Id && result.Id > 0)
            $uibModalInstance.close(result);
        });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    // Modifica elemento
    function editItem(item) {
      return datacontext.settings_update(item).then(function (data) {
        if (!data || data.Id == null || data.Id == 0) {
          logError("Errore durante la creazione del dato");
          return null;
        }
        return data;
      });
    }

    function getListAziende() {
      return datacontext.azienda_getAllList().then(function (data) {
        return $scope.item.aziende = data;
      });
    }
  }
})();
